import { Controller } from "@hotwired/stimulus";

// Dispara el evento Purchase/CompleteRegistration de Meta y luego redirige a la
// accion post-compra (landing / URL). El pixel no expone callback de
// finalizacion, asi que damos un margen para que la request alcance a salir
// antes de abandonar la pagina. Ese margen es tambien el fallback: pase lo que
// pase con Meta, el redirect igual dispara y el usuario nunca queda atascado.
export default class extends Controller {
  static values = {
    redirectUrl: String,
    pixel: Boolean,
    eventName: String,
    eventKey: String,
    contentIds: Array,
    currency: String,
    amount: String,
  };

  static REDIRECT_MARGIN_MS = 500;

  connect() {
    if (this.pixelValue) {
      window.MetaPixel?.trackOnce(this.eventNameValue, this.eventKeyValue, {
        content_ids: this.contentIdsValue,
        currency: this.currencyValue,
        value: this.amountValue,
      });
    }

    if (this.redirectUrlValue) {
      const margin = this.pixelValue ? this.constructor.REDIRECT_MARGIN_MS : 0;
      this.redirectTimeout = setTimeout(() => {
        window.location.href = this.redirectUrlValue;
      }, margin);
    }
  }

  disconnect() {
    clearTimeout(this.redirectTimeout);
  }
}
